<template>
    <div>
        <compFormEdit
            class="margin-top-15 margin-right-15"
            ref="editform"
            :formdata="getBase"
            v-model="formData"
            :labelWidth="120"
            :col="1">
        </compFormEdit>
        <div class="color-error text-center">{{$t('fbb.account.cusdisacountrate_sure_copy', { defaultValue: '确认复制后，目标组织对应承运商服务下原最低收费会被清除，请谨慎操作！' })}}</div>
        <div class="text-right margin-top-10">
            <vButton theme="primary" @click="submit">{{$t('fbb.account.cusdisacountrate_sure', { defaultValue: "确认复制" })}}</vButton>
            <vButton class="margin-left-10" @click="cancel">{{$t('global.common.operation_cancel', { defaultValue: "取消" })}}</vButton>
        </div>
    </div>
</template>

<script>
import { HttpCopyMinimumCharge } from '@/service/account';
import { HttpGetServiceList, HttpGetServiceProductList } from "@/service/fedex";
import { HttpOtherLogiServiceList,HttpGetCarrierGroupByOrg } from "@/service/carrieraccount";
import { mapGetters } from 'vuex';
export default {
    data(){
        return{
            formData:{
                regionCode: ''
            },
            groupServiceList:[],
            groupList:[],
        }
    },
    components: {
		compFormEdit: () => import("@components/templates/formedit"),
	},
    computed:{
        ...mapGetters('dictionary', ['getNextOrgList','getCarrierServiceList','getCusproductList','getCountryList']),
        getBase(){
            return [
                {
                    label: this.$t('fbb.carrier.extra_source',{defaultValue:'来源组织'}),
                    key: "sourceOrgId",
                    tag:'Select',
                    options:this.getNextOrgList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val)
                            // this.getOrgGroupList(val);
                            HttpGetServiceList({
                            // HttpGetCarrierGroupByOrg({
                                // contextId:global.SYSID,
                                customerId: val,
                            }).then(
                                (res) => {
                                    this.groupList = res.data.map(item => {
                                        return {
                                            value: item.id,
                                            label: item.carrierGroupCode,
                                            attach: {
                                                ...item
                                            },
                                        };
                                    });
                                },
                                (err) => {
                                    this.$VMessage.error(err.message);
                                }
                            );
                        }
                    },
                },
                {
                    // label: this.$t('fbb.alloment.carrier_code', { defaultValue: '物流商' }),
                    label: "物流产品",
                    key: "sourceGroupId",
                    tag: 'Select',
                    options:this.groupList,
                    props:{
                        filterable:true
                    },
                    on:{
                        'on-change':(val)=>{
                            if(val)
                            // this.getGroupServiceList(val);
                            HttpGetServiceProductList({
                            // HttpOtherLogiServiceList({
                                contextId:global.SYSID,
                                carrierGroupId: val,
                                orgId: this.formData.sourceOrgId,
                            }).then(
                                (res) => {
                                    this.groupServiceList = res.data.map(item => {
                                        return {
                                            value: item.id,
                                            label: item.code,
                                            attach: {
                                                ...item
                                            },
                                        };
                                    });
                                    this.getRegionCountry(val)
                                },
                                (err) => {
                                    this.$VMessage.error(err.message);
                                }
                            );
                        }
                    },
                },
                {
                    // label: this.$t('fbb.carrier.extra_source_service',{defaultValue:'来源承运商服务'}),
                    label: this.$t('fbb.alloment.carrier_server', { defaultValue: '物流商服务' }),
                    key: "sourceCarrierServiceId",
                    tag:'Select',
                    options:this.groupServiceList,
                    props:{
                        filterable:true
                    },
                    // on:{
                    //     'on-change':(val)=>{
                    //         this.getRegionCountry(val)
                    //     }
                    // },
                },
                {
                    label: this.$t('erp.channelbase.country', { defaultValue: '国家' }),
                    query:true,
                    tag: "div",
                    children: (h) => {
                        const region=this.getCountryList.filter(item=>item.value===this.formData.regionCode)[0]
                        return (
                            <div class="font-bold">
                                {region ? region.label : "--"}
                            </div>
                        );
                    },
                    show:this.formData.sourceDiscountType!=10,
                },
                {
                    label: "来源项目",
                    tag: 'Select',
                    key: 'sourceLineId',
                    show:true,
                    options:this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                    required:false,
                },
                {
                    label: this.$t('fbb.carrier.extra_target_org',{defaultValue:'目标组织'}),
                    key: "orgIds",
                    tag:'Select',
                    props:{
                        filterable:true,
                        multiple:true,
                    },
                    options:this.getNextOrgList,
                },
                {
                    label: this.$t('fbb.customerMinimumCharges..targetCarrierService',{defaultValue:'目标承运商服务'}),
                    key: "carrierServiceId",
                    tag:'Select',
                    options:this.groupServiceList,
                    props:{
                        filterable:true
                    }
                },
                {
                    label: "目标项目",
                    tag: 'Select',
                    key: 'lineId',
                    show:true,
                    options:this.getCusproductList,
                    props:{
                        filterable:true,
                    },
                    required:false,
                },
            ]
        }
    },
    methods:{
        getRegionCountry(val){
            const groupService=this.groupList.filter(item=>{
                return item.value==val
            })
            this.formData.regionCode=groupService[0]?groupService[0].attach.regionCode:''
        },
        submit(){
            HttpCopyMinimumCharge({
                ...this.formData
            }).then(res=>{
                this.$VMessage.success(res.data)
                this.cancel()
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
        cancel(){
            this.$emit('on-close')
        },
    },
}
</script>

